import React from 'react';

function PersonalAgreement() {
  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-body">
        <h1 className="card-title text-center mb-4">СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ
        ПОЛЬЗОВАТЕЛЕЙ ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ «ПРОСТО ПОДПИШИ» (далее — «Программа»)</h1>
<div className="mb-4"> 
<p>Физическое лицо (далее — «Субъект»), заполняя свои персональные данные в Программе, дает свое согласие Индивидуальному предпринимателю Разиной Марине Андреевне, ИНН: 745701981147, ОГРНИП: 325745600080301 (далее — «Оператор»), на обработку персональных данных в указанном в настоящем документе объеме.</p>

<p>Давая согласие, физическое лицо подтверждает, что:</p>
<ul>
<li>действует свободно, своей волей и в своем интересе;</li>
<li>является дееспособным;</li>
<li>согласие является конкретным, информированным и сознательным.</li>
</ul>

<p>1. Согласие дается на обработку персональных данных как с использованием средств автоматизации, так и без использования таких средств.</p>

<p>2. Цели обработки персональных данных:</p>

<p className='ps-2'>2.1. Цель: Предоставление Субъекту возможности использования функций Программы. </p>
<p className='ps-5'><b>Категории и перечень обрабатываемых данных:</b> фамилия, имя, отчество; адрес электронной почты;  адрес места жительства; адрес регистрации; номер телефона; данные документа, удостоверяющего личность.</p>
<p className='ps-5'><b>Категории субъектов, персональные данные которых обрабатываются:</b> Пользователи Программы.</p>
<p className='ps-5'><b>Способы обработки:</b> сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, обезличивание, блокирование, удаление, уничтожение персональных данных.</p>
<p className='ps-5'><b>Срок обработки и хранения:</b> до получения от Субъекта персональных данных требования о прекращении обработки / отзыва согласия либо 10 (десять) лет.</p>
<p className='ps-5'><b>Порядок уничтожения персональных данных при достижении цели их обработки или при наступлении иных законных оснований:</b> лицо, ответственное за обработку персональных данных, производит стирание данных методом перезаписи (замена всех единиц хранения информации на «0») с составлением акта об уничтожении персональных данных.</p>
<p className='ps-2'>2.2. Цель: обработка обращений, претензий, жалоб, запросов, сообщений, направляемых Оператором и Субъектом друг другу.</p>
<p className='ps-5'><b>Категории и перечень обрабатываемых данных:</b> фамилия, имя, отчество; адрес электронной почты; адрес места жительства; адрес регистрации; номер телефона; данные документа, удостоверяющего личность; реквизиты банковской карты; номер расчетного счета.</p>
<p className='ps-5'><b>Категории субъектов, персональные данные которых обрабатываются:</b> Соискатели; Контрагенты; Представители контрагентов; Клиенты; Пользователи Программы; Законные представители. </p>
<p className='ps-5'><b>Способы обработки:</b> сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, обезличивание, передача (доступ, предоставление) блокирование, удаление, уничтожение персональных данных.</p>
<p className='ps-5'><b>Срок обработки и хранения:</b> до получения от субъекта персональных данных требования о прекращении обработки/отзыва согласия либо 10 (десять) лет.</p>

<p>3. Персональные данные не являются общедоступными.</p>

<p>4. Оператор осуществляет связанные с обработкой персональных данных процессы в целях выполнения своих обязательств. </p>
<p>Такими обязательствами Оператора являются:</p>
<ul>
<li>предоставление Субъекту персональных данных доступа к Программе, в том числе для постановки и выполнения различных задач Оператора;</li>
<li>оказание консультационной и технической поддержки Субъекту персональных данных;</li>
<li>обеспечение работоспособности и безопасности Программы.</li>
</ul>

<p>5. Правовым основанием обработки персональных данных является совокупность правовых актов, во исполнение которых и в соответствии с которыми Оператор осуществляет обработку персональных данных. Правовым основанием обработки персональных данных Пользователя является: согласие на обработку персональных данных.</p>

<p>6. В ходе обработки с персональными данными будут совершены следующие действия: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), электронное копирование, извлечение, использование, обезличивание, блокирование, удаление и уничтожение.</p>

<p>7. Персональные данные обрабатываются до удаления персональных данных Субъекта. Также обработка персональных данных может быть прекращена по запросу Субъекта персональных данных.</p>

<p>8. Согласие может быть отозвано Субъектом персональных данных или его представителем путем направления письменного заявления Оператору по адресу электронной почты: prosto.podpishi@mail.ru.</p>

<p>9. В случае отзыва физическим лицом или его представителем согласия на обработку персональных данных Оператор вправе продолжить обработку персональных данных без согласия физического лица при наличии оснований, указанных в пунктах 2 – 11 части 1 статьи 6, части 2 статьи 10 и части 2 статьи 11 Федерального закона № 152-ФЗ «О персональных данных» от 27 июля 2006 г.</p>

<p>10. Согласие действует все время до момента прекращения обработки персональных данных, указанного в п. 7 данного Согласия.</p>

</div>




        </div>
      </div>
    </div>
  );
}

export default PersonalAgreement; 